<template>
  <div class="line-item"> 
       <div class="heading ml-2" style="display:flex;">                 
         <v-btn class="adminLibelleBtn"  :to="{name:'EditEnseigne',params:{itemid:item.id}}" flat :title="$t('Admin.Enseigne.List.ReachEnseigneTooltip')" >{{item.ENS_LIBELLE}}</v-btn>    
       </div>
   </div>
 </template>
 
 <script lang="ts">
 import Vue from 'vue'
 import Component from 'vue-class-component'
 import { AloDbBase } from '@/models/alodb/AloDbBase';
import { AloDbEnseigne } from '@/models/alodb/AloDbEnseigne';
 
 
 @Component({
   name: 'AdminEnseigneListLine',   
    props: {  
      item:{
        type:AloDbEnseigne,
        required:true
      }      
   }
 })
 export default class AdminEnseigneListLine extends Vue {
   item!:AloDbEnseigne
 }
 </script>